import React, { useState } from 'react';
import { Popper } from '@mui/material';

function ImgModal({ image, ImageURL, imgBool, pdf }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  return (
    <a
      id="Attachments"
      href={ImageURL}
      target={pdf ? '_blank' : ''}
      rel="noopener noreferrer"
      style={{
        fontSize: '13px',
        padding: '0px 5px',
        width: '115px',
        wordWrap: 'break-word',
        fontWeight: 'bold',
      }}
    >
      <img
        src={image}
        alt="img"
        width="50px"
        height="50px"
        aria-describedby={id}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      />
      {imgBool ? null : (
        <Popper id={id} open={open} anchorEl={anchorEl}>
          <img src={image} alt="img" width="100px" height="100px" />
        </Popper>
      )}
    </a>
  );
}

export default ImgModal;
